import React from 'react';

import {CharacterSheetEntryFragment, useClassesQuery, useOriginsQuery, useSpeciesQuery} from '../../generated/types';
import type {CharacterState} from './character/model/character-state';

import css from './sheets.module.css';

const dateFormat = new Intl.DateTimeFormat('ru-RU', {day: 'numeric', month: 'long', year: 'numeric'});

type Titled = {id: string; title: string};

export type TitleLookups = {
	classes: Titled[];
	species: Titled[];
	origins: Titled[];
};

export const useTitleLookups = (): TitleLookups => ({
	classes: useClassesQuery({ssr: false}).data?.classes || [],
	species: useSpeciesQuery({ssr: false}).data?.species || [],
	origins: useOriginsQuery({ssr: false}).data?.origins || [],
});

export const SheetSummary: React.FC<{sheet: CharacterSheetEntryFragment; titles: TitleLookups}> = ({sheet, titles}) => {
	const {classes, species, origins} = titles;
	const state = (sheet.data || {}) as Partial<CharacterState>;

	const classesText = (state.classes || [])
		.map(({classId, level}) => `${classes.find((entry) => entry.id === classId)?.title || classId} ${level}`)
		.join(' / ');
	const details = [
		classesText,
		species.find((entry) => entry.id === state.specieId)?.title,
		origins.find((entry) => entry.id === state.originId)?.title,
	].filter(Boolean);

	return (
		<span className={css.sheetCaption}>
			{details.join(' · ') || 'Персонаж ещё не собран'}
			<span className={css.muted}> · изменён {dateFormat.format(new Date(sheet.updatedAt))}</span>
		</span>
	);
};
